import { DecimalPipe, NgClass } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  FormField,
  FormSelect,
  PageLayout,
  FormTextarea,
} from '@one-of-one/form';
import {
  Pack,
  PACKS,
  ParticipantDto,
  Profession,
  RegistrationType,
} from '@one-of-one/models';
import { Reservation } from '../../../../services/reservation';
import { Router } from '@angular/router';

@Component({
  selector: 'app-with-accomodation',
  imports: [
    ReactiveFormsModule,
    PageLayout,
    FormField,
    FormSelect,
    NgClass,
    DecimalPipe,
    FormTextarea,
  ],
  templateUrl: './with-accomodation.html',
})
export class WithAccomodation implements OnInit {
  private fb = inject(FormBuilder);
  private readonly reservService = inject(Reservation);
  private readonly router = inject(Router);

  totalAmount = signal(0);

  isSubmitting = signal(false);

  professions = [
    {
      label: 'Médecin',
      value: Profession.DOCTOR,
    },
    {
      label: 'Non médecin',
      value: Profession.NON_DOCTOR,
    },
    {
      label: 'Résident',
      value: Profession.RESIDENT,
    },
  ];

  packOptions = PACKS.slice(2, PACKS.length + 1);

  registrationForm = this.fb.group(
    {
      pack: ['', [Validators.required]],
      familyName: ['', [Validators.required, Validators.minLength(2)]],
      firstName: ['', [Validators.required, Validators.minLength(2)]],
      profession: ['', [Validators.required]],
      speciality: ['', [Validators.required]],
      phoneNumber: [
        '',
        [Validators.required, Validators.pattern('^[- +()0-9]+$')],
      ],
      email: ['', [Validators.required, Validators.email]],
      city: ['', [Validators.required]],
      country: ['', [Validators.required]],
      comment: ['', [Validators.maxLength(300)]],
    },
    { updateOn: 'submit' },
  );

  ngOnInit(): void {
    this.registrationForm.valueChanges.subscribe((value) => {
      this.totalAmount.set(
        this.packOptions.find((pack) => pack.id === value.pack)?.price || 0,
      );
    });
  }

  private mapFormToParticipant(): ParticipantDto {
    const v = this.registrationForm.value;

    return {
      familyName: v.familyName || '',
      firstName: v.firstName || '',
      profession: v.profession as Profession,
      speciality: v.speciality || '',
      phoneNumber: v.phoneNumber || '',
      email: v.email || '',
      city: v.city || '',
      country: v.country || '',
      pack: v.pack as Pack,
      roommate: 0,
    };
  }

  onSubmit() {
    if (this.registrationForm.invalid) {
      this.registrationForm.markAllAsTouched();
      return;
    }

    this.isSubmitting.set(true);

    this.reservService
      .createReservation({
        type: RegistrationType.WITH_ACCOMODATION,
        comment: this.registrationForm.value.comment || '',
        participants: [this.mapFormToParticipant()],
      })
      .subscribe({
        next: (data) => {
          this.isSubmitting.set(false);
          this.router.navigate(['confirmation', data]);
        },
        error: (error) => {
          this.isSubmitting.set(false);
          console.error(error);
        },
      });
  }

  onCancel() {
    this.router.navigate(['/']);
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.registrationForm.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched));
  }

  selectRoom(type: string) {
    this.registrationForm.get('pack')?.setValue(type);
  }
}
